<div class="row">
  <div class="col" *ngIf="isDownload">
    <button
      class="btn btn-sm mx-1"
      (click)="onActionClick('isPresigned', link)"
      [ngClass]="!link ? 'disabled btn-outline-secondary' : 'btn-outline-primary'"
    >
      <i-feather name="download"></i-feather>
    </button>
  </div>
  <div class="col" *ngIf="!isDownload">
    <a
      class="btn btn-sm mx-1"
      [ngClass]="!link ? 'disabled btn-outline-secondary' : 'btn-outline-primary'"
      [href]="link"
      target="_blank"
      >{{ 'open.value' | translate }}</a
    >
  </div>
</div>
